import { COLUMN_GROUPS } from './excel-columns.utils';

export const calculateChunkSizes = (totalRows: number, maxRowsPerFile: number): number[] => {
   if (totalRows <= maxRowsPerFile) {
      return [totalRows];
   }

   const fileCount = Math.ceil(totalRows / maxRowsPerFile);
   const rowsPerFile = Math.ceil(totalRows / fileCount);

   const chunks: number[] = [];
   let remainingRows = totalRows;

   for (let i = 0; i < fileCount; i++) {
      const chunkSize = Math.min(rowsPerFile, remainingRows);
      chunks.push(chunkSize);
      remainingRows -= chunkSize;
   }

   return chunks;
};

export const getExportColumns = (visibleColumns: string[]): string[] => {
   const conditionalMappings = {
      material: {
         triggers: ['materialGradeId', 'materialGrade'],
         columns: ['category', 'matType', 'subTypeId'],
      },
      item: {
         triggers: ['itemNumber', 'itemName'],
         columns: ['isBase', 'parentItemNo'],
      },
      dwp: {
         triggers: ['cpNetWeight', 'partsWeight'],
         columns: ['dwpDeviation'],
      },
   };

   const allColumns: string[] = [];
   const allGroups = [COLUMN_GROUPS.item, COLUMN_GROUPS.subitem];

   const shouldIncludeConditional = (mapping: typeof conditionalMappings[keyof typeof conditionalMappings]) => {
      return mapping.triggers.some((trigger) => visibleColumns.includes(trigger));
   };

   const conditionalColumns = new Set([
      ...conditionalMappings.material.columns,
      ...conditionalMappings.item.columns,
      ...conditionalMappings.dwp.columns,
   ]);

   for (const group of allGroups) {
      for (const colId of group) {
         if (conditionalColumns.has(colId)) {
            if (conditionalMappings.material.columns.includes(colId) && shouldIncludeConditional(conditionalMappings.material)) {
               allColumns.push(colId);
            } else if (conditionalMappings.item.columns.includes(colId) && shouldIncludeConditional(conditionalMappings.item)) {
               allColumns.push(colId);
            } else if (conditionalMappings.dwp.columns.includes(colId) && shouldIncludeConditional(conditionalMappings.dwp)) {
               allColumns.push(colId);
            }
         } else if (visibleColumns.includes(colId)) {
            allColumns.push(colId);
         }
      }
   }

   return allColumns;
};

export const getStageMessage = (
   stage: 'fetching' | 'processing' | 'generating' | 'complete' | 'cancelling',
   currentFile?: number,
   totalFiles?: number
): string => {
   switch (stage) {
      case 'fetching':
         return 'Fetching items from the database...';
      case 'processing':
         if (totalFiles && totalFiles > 1 && currentFile) {
            return `Processing and generating file ${currentFile} of ${totalFiles}...`;
         }
         return 'Processing items...';
      case 'generating':
         if (currentFile && totalFiles && totalFiles > 1) {
            return `Processing and generating file ${currentFile} of ${totalFiles}...`;
         }
         return 'Generating Excel file...';
      case 'complete':
         return 'Export complete!';
      case 'cancelling':
         return 'Cancelling export...';
      default:
         return 'Exporting...';
   }
};
